import { render, staticRenderFns } from "./startShopping.vue?vue&type=template&id=dd70cac6&"
import script from "./startShopping.vue?vue&type=script&lang=js&"
export * from "./startShopping.vue?vue&type=script&lang=js&"
import style0 from "./startShopping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports